(() => {
  'use strict';
  if (window.DACCloseControl) return;
  const fallbackLabel = document.currentScript?.dataset.closeLabel || 'Close';
  function apply(button, label) {
    if (!button || button.tagName !== 'BUTTON') return;
    if (!button.hasAttribute('type')) button.type = 'button';
    if (label) button.setAttribute('aria-label', label);
    button.classList.add('dac-close-control');
    // Swym re-appends its own icon-font glyph (span.swym-icon) next to the injected
    // icon after the button is enhanced, which stacked two X marks in the wishlist
    // notification. Re-run the replacement whenever the icon is not the only child.
    let svg = button.querySelector(':scope > svg[data-dac-close-icon]');
    if (svg && button.childNodes.length === 1) return;
    button.dataset.dacCloseReady = 'true';
    if (!svg) {
      svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('data-dac-close-icon', '');
      for (const [name, value] of Object.entries({ viewBox:'0 0 24 24', width:'18', height:'18', fill:'none', stroke:'currentColor', 'stroke-width':'1.6', 'stroke-linecap':'round', 'aria-hidden':'true', focusable:'false' })) svg.setAttribute(name, value);
      const path = document.createElementNS(svg.namespaceURI, 'path');
      path.setAttribute('d', 'm6 6 12 12M18 6 6 18'); svg.append(path);
    }
    button.replaceChildren(svg);
  }
  window.DACCloseControl = { apply };

  // Explicit integrations only. App-owned buttons keep their node, selectors,
  // disabled state and event handlers. Never attach a replacement close action.
  const integrations = [
    { selector: 'button[data-dac-close]' },
    { selector: '#vp-images-modal button[data-vp-modal-navigation="close"]', overlay: true },
    { selector: '#dac-collection-filters button.dac-filter-close' },
    { selector: '#search_bar button.searchBar-icon-close' },
    { selector: '#snize-modal-mobile-filters-dialog > button.snize-close-button' },
    { selector: '.wishlist-modal__container > header > button.wishlist-modal__js-close' },
    { selector: '.swym-modal__container > header > button.swym-modal__js-close' },
    { selector: '.download-app-banner-ios button.download-app-banner-ios__close' },
    { selector: '.download-app-banner-android button.download-app-banner-android__close' },
    { selector: '.quiz-mobile-top-banner button.quiz-mobile-top-banner__close' },
    { selector: '.pswp button.pswp__button--close' },
    { selector: '#swym-plugin .swym-add-wishlist-modal button.swym-close-btn', overlay: true },
    { selector: '#swym-plugin .swym-notification-wishlist button.swym-close-btn', overlay: true },
    { selector: '#swym-plugin .dac-wishlist-confirmation button.swym-close-btn', overlay: true },
    { selector: '.okeReviews button.oke-modal-close', overlay: true },
    { selector: '.dac-cart-confirmation button.dac-cart-confirmation__close' },
    { selector: '.country-popup__header button.country-popup__button-close' },
    { selector: '.Collection-refine-header button.js-refine-close' },
    { selector: '.dac-spin-to-win button.dac-spin-to-win__close', overlay: true },
    { selector: 'button.trading-cards-login-modal__close', overlay: true }
  ];
  function enhance(button, integration) {
    // Derive an absent accessible name before replacing a legacy image/icon.
    const labelled = button.getAttribute('aria-label') || button.getAttribute('aria-labelledby');
    const text = button.textContent.trim();
    const label = labelled ? undefined : button.title || button.querySelector('img[alt]')?.alt ||
      (text && !/^[×✕✖xX]$/.test(text) ? text : fallbackLabel);
    if (integration.overlay) button.setAttribute('data-dac-close-overlay', '');
    apply(button, label);
  }
  function scan(root) {
    for (const integration of integrations) {
      if (root.matches?.(integration.selector)) enhance(root, integration);
      root.querySelectorAll(integration.selector).forEach(button => enhance(button, integration));
    }
  }
  function start() {
    scan(document.body);
    // Swym, Okendo, PhotoSwipe and theme templates insert their controls later.
    // Inspect added subtrees only; do not rescan the whole page on every change.
    new MutationObserver(records => {
      for (const record of records) {
        for (const node of record.addedNodes) {
          if (node.nodeType === 1) scan(node);
        }
        const owner = record.target.closest?.('button');
        if (owner) scan(owner);
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();



(() => {
  const selector = '.dac-seasonal-info';
  const close = (details, restoreFocus = false) => {
    details.open = false;
    if (restoreFocus) details.querySelector('summary').focus();
  };
  document.addEventListener('click', event => {
    const current = event.target.closest(selector);
    document.querySelectorAll(selector + '[open]').forEach(details => {
      if (details !== current) close(details);
    });
    if (current) {
      event.stopPropagation();
      if (event.target.closest('summary')) {
        event.preventDefault();
        current.open = !current.open;
      }
    }
  }, true);
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const current = event.target.closest(selector);
    if (current && current.open) {
      event.preventDefault();
      event.stopPropagation();
      close(current, true);
    }
  }, true);
})();
